import { Backdrop, Button, Checkbox, FormControlLabel, Grid, IconButton, Switch, Typography } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik';
import * as yup from 'yup';
import axios from 'axios';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import { Delete, EditNote } from '@mui/icons-material';
import _ from 'lodash';
import CustomDataGrid from '../../../../../components/dataTable/customDataGrid';
import CustomTextField from '../../../../../components/utils/input/customTextField';
import Modal from '../../../../../components/utils/modal/modal';
import DeletePage from '../../../../../components/utils/deleteModal/deletePage';
import CustomdropDown from '../../../../../components/utils/dropDown/customdropDown';
import Loader from '../../../../../components/loader/loader';
import { Helmet } from 'react-helmet-async';

const SubMenu = () => {
    const dispatch = useDispatch()
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [search, setSearch] = useState("");
    const [data, setData] = useState([])
    const [open, setOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [openDialog, setOpenDialog] = useState(false)
    const [active, setActive] = useState(false)
    const [activeId, setActiveId] = useState(null)
    const [menuData, setMenuData] = useState([])
    const [isLoader, setIsLoader] = useState(false); //loader


    const validationSchema = yup.object({
      subMenuName : yup.string().required(),
      subMenuUrl : yup.string().required(),
      subMenuOrder : yup.string().required(),
      subMenuIcon : yup.string().required(),
      menuCategory: yup.object().required(),

      })
      
      const formik = useFormik({
        initialValues :{
        subMenuName : "",
        subMenuUrl:"",
        subMenuOrder:"",
        subMenuIcon:"",
        menuCategory:null

        },
        validationSchema:validationSchema,
      onSubmit: isEdit ? handleUpdate : handleCreate
      })
      
      const onCreate = ()=>{
      setOpen(true)
      formik.resetForm()
      setIsEdit(false)
      }
      
      function handleCreate(){
        console.log("first")
        const subMenuData = {
          menu_id:formik.values.menuCategory.id,
          sub_menu_name:formik.values.subMenuName,
          sub_menu_url:formik.values.subMenuUrl,
          sub_menu_icon:formik.values.subMenuIcon,
          sub_menu_order:formik.values.subMenuOrder,
          company_id:1
        }
        setIsLoader(true);
        axios.post('/v1/submenu', subMenuData)
        .then(res=>{
          console.log(res)
          setOpen(false)
          getSubMenuData()
          dispatch(setSnackbar(true, 'success', 'Created Successfully'))
          setIsLoader(false);
        })
        .catch(err=>{
          dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
          console.log(err)
          setIsLoader(false);
        })
      }
      
      function onEdit(e){
      console.log(e)
      formik.setFieldValue('subMenuName',e.subMenuName)
      formik.setFieldValue('subMenuUrl',e.subMenuUrl)
      formik.setFieldValue('subMenuOrder' , e.subMenuOrder)
      formik.setFieldValue('subMenuIcon' , e.subMenuIcon)
      menuData.filter(value => value.id === e.menuId).map(val => formik.setFieldValue('menuCategory' , val))
      setIsEdit(true)
      setOpen(true)
      setActive(e.isActive)
      setActiveId(e.id)
      }
      
      function handleUpdate(){
        const subMenuData = {
            menu_id:formik.values.menuCategory.id,
            sub_menu_name:formik.values.subMenuName,
            sub_menu_url:formik.values.subMenuUrl,
            sub_menu_icon:formik.values.subMenuIcon,
            sub_menu_order:formik.values.subMenuOrder,
            company_id:1
          }
          setIsLoader(true);
        axios.put(`/v1/submenu/${activeId}`, subMenuData)
        .then(res=>{
          setOpen(false)
          console.log(res)
          getSubMenuData()
          dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
          setIsLoader(false);
        })
        .catch(err=>{
          dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
          console.log(err)
          setIsLoader(false);
        })
      console.log('update')
      }
      
      function OnDelete(id){
        setOpenDialog(true)
        setActiveId(id)
      }  
      
      const handleDelete = () =>{
        setIsLoader(true);
        axios.delete(`/v1/submenu/1/${activeId}`)
        .then(res=>{
          setOpenDialog(false)
          getSubMenuData()
          console.log(res)
          setIsLoader(false);
          setOpen(false)
          dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
        })
        .catch(err=>{
          dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
          console.log(err)
          setIsLoader(false);
        })
      console.log('fasdf')
      }
        const columns = [
          {
            field: "sno",
            headerName: "S.no",
            minWidth: 70,
            maxWidth: 100,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "menuName",
            headerName: "Menu Name",
            minWidth: 180,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "subMenuName",
            headerName: "Sub Menu Name",
            minWidth: 180,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "subMenuUrl",
            headerName: "Sub Menu Url",
            minWidth: 180,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "subMenuOrder",
            headerName: "Sub Menu Order",
            minWidth: 180,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: 'subMenuIcon',
            headerName: 'Sub Menu Icon',
            minWidth: 180,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            disableExport: true ,
            renderCell: (params) => (
              <div dangerouslySetInnerHTML={{ __html: params.row.subMenuIcon }} />
            ),
          },
        //   {
        //     field: "subMenuIcon",
        //     headerName: "Sub Menu Icon",
        //     minWidth: 180,
        //     headerAlign: "center",
        //     align: "center",
        //     sortable: false,
        //   },
        //   {
        //     field: "active",
        //     headerName: "Status",
        //     minWidth: 180,
        //     headerAlign: "center",
        //     align: "center",
        //     sortable: false,
        //     disableColumnMenu: true,
        //     renderCell: (params) => (
        //       <div className="">
        //         <Switch checked={params.row.isActive}/>
        //       </div>
        //     )
        //   },
          {
            field: 'action',
            headerName: 'Action',
            minWidth: 100,
            headerAlign: "center",
            align: "center",
            editable: false,
            sortable: false,
            disableColumnMenu: true,
            disableExport: true ,
            renderCell: (params) => (
              <div className='flex justify-center w-full'>
                <IconButton onClick={()=>onEdit(params.row)} >
                  <EditNote sx={{color:"#1972d2",fontSize:22}}/>
                </IconButton>
                <IconButton onClick={() => OnDelete(params.id)}>
                  <Delete sx={{color:"red",fontSize:22}}/>
                </IconButton>
              </div>
            ),
          },
        ];
      
        const rows = _.map(data,(val,idx)=>({
          id: val.id,
          sno:++idx,
          isActive: val.is_active,
          subMenuName : val.sub_menu_name,
          subMenuUrl:val.sub_menu_url,
          subMenuOrder:val.sub_menu_order,
          subMenuIcon:val.sub_menu_icon,
          menuName:val.menu_name,
          menuId:val.menu_id
        }))
      
        const props = {
          rows: rows,
          columns: columns,
          search: search,
          setSearch : setSearch,
          page: page,
          setPage: setPage,
          rowsPerPage: rowsPerPage,
          setRowsPerPage: setRowsPerPage,
          pageCount: pageCount,
          pageOption: pageOption,
        };
      console.log(data)
      const getSubMenuData = () =>{
        const url = `/v1/submenu/1/${rowsPerPage}/${page + 1}`
        const searchUrl = `/v1/submenu/1/${rowsPerPage}/${page + 1}/${search}`
        setIsLoader(true);
        axios.get(search === '' ? url : searchUrl)
        .then(res=>{
          setData(res.data.data)
          setPageCount(res.data.meta.pagination.total)
          setIsLoader(false);
        })
        .catch(err=>{
          console.log(err)
          setIsLoader(false);
          dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
        })
      }
      const getMainMenuData = () =>{
        setIsLoader(true);
        axios.get(`/v1/menu/list/1`)
        .then(res=>{
            console.log(res)
          setMenuData(res.data)
          setIsLoader(false);
        })
        .catch(err=>{
          console.log(err)
          setIsLoader(false);
          dispatch(setSnackbar(true, 'error', err.response.data.message))
        })
      }
      useEffect(()=>{
        getSubMenuData()
      },[rowsPerPage, page, search])
        useEffect(() => {
            getMainMenuData()
        },[])
      
  return (
    <Fragment>
      <Helmet>
        <title>Sub menu</title>
      </Helmet>
        <Typography variant='h5'>Sub Menu</Typography>

        {!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
{open &&
        <Modal onClose={setOpen}  onSave={formik.handleSubmit} formik={formik} isEdit={isEdit}>
          <Grid container spacing={2}>
          <Grid item xs={12} md={4} lg={3} >
              <CustomdropDown
                id="menuCategory"
                data={menuData}
                optionLabel={(option) => option.menu_name}
                value={formik.values.menuCategory}
                onchange={(e, value) => {
                  formik.setFieldValue("menuCategory", value);
                }}
                optionEqual={(option, value) => option.menu_name === value.menu_name}
                placeholder="Select Category"
                helperText={formik.touched.menuCategory && formik.errors.menuCategory}
                errorMsg={
                  formik.touched.menuCategory && Boolean(formik.errors.menuCategory)
                }
                title="Category"
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
            <CustomTextField id='subMenuName' value={formik.values.subMenuName} title='Sub Menu Name' multiple={false} placeholder='Enter submenu Name' onchange={formik.handleChange} errorMsg={formik.touched.subMenuName && Boolean(formik.errors.subMenuName)} helperText={formik.touched.subMenuName && formik.errors.subMenuName}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
            <CustomTextField id='subMenuUrl' value={formik.values.subMenuUrl} title='Sub Menu Url' multiple={false} placeholder='Enter submenu Url' onchange={formik.handleChange} errorMsg={formik.touched.subMenuUrl && Boolean(formik.errors.subMenuUrl)} helperText={formik.touched.subMenuUrl && formik.errors.subMenuUrl}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
            <CustomTextField id='subMenuOrder' value={formik.values.subMenuOrder} title='Sub Menu Order' multiple={false} placeholder='Enter submenu Order' onchange={formik.handleChange} errorMsg={formik.touched.subMenuOrder && Boolean(formik.errors.subMenuOrder)} helperText={formik.touched.subMenuOrder && formik.errors.subMenuOrder}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
            <CustomTextField id='subMenuIcon' value={formik.values.subMenuIcon} title='Sub Menu Icon' multiple={false} placeholder='Enter submenu Icon' onchange={formik.handleChange} errorMsg={formik.touched.subMenuIcon && Boolean(formik.errors.subMenuIcon)} helperText={formik.touched.subMenuIcon && formik.errors.subMenuIcon}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3} className="flex items-center">
            <FormControlLabel  control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
            </Grid>
            
          </Grid>
        </Modal>
      }
      <Grid className="bg-white rounded-md p-2 my-3">
        <CustomDataGrid props={props} />
      </Grid>
      <Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader} /> */}
    </Fragment>
  )
}

export default SubMenu